module.exports = __webpack_public_path__ + "img/shot4.ca917c0.png";